import { useMutation, useQueryClient } from '@tanstack/vue-query'
import { hcaClientFactory } from '@/api/factories/HcaClientFactory'
import { ComponentType } from '@/configuration/component/component-types'

export const useGeneralCommentsDeleteMutation = (generalCommentComponentType: ComponentType) => {
    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: async (payload: { generalCommentComponentSid: string; commentId: number }) =>
            hcaClientFactory.generalCommentsApi.deleteGeneralComment(payload.commentId),
        onSuccess: async (response, payload) => {
            if (generalCommentComponentType === ComponentType.Transformer) {
                await queryClient.resetQueries({ queryKey: ['transformers', payload.generalCommentComponentSid, 'generalComments'] })
            } else if (generalCommentComponentType === ComponentType.Generator) {
                await queryClient.resetQueries({ queryKey: ['generators', payload.generalCommentComponentSid, 'generalComments'] })
            }
        },
    })
}
